"use strict";

var _interopRequireDefault = require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("./index.vue"));
//
//
//
//
var _default = {
  name: "HotelCoupon",
  components: {
    Coupon: _index.default
  },
  data: function data() {
    return {
      platform: 2
    };
  },
  created: function created() {},
  methods: {}
};
exports.default = _default;